import { render, staticRenderFns } from "./ExamGroupCard.vue?vue&type=template&id=68b64ba4&scoped=true&"
import script from "./ExamGroupCard.vue?vue&type=script&lang=ts&"
export * from "./ExamGroupCard.vue?vue&type=script&lang=ts&"
import style0 from "./ExamGroupCard.vue?vue&type=style&index=0&id=68b64ba4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b64ba4",
  null
  
)

export default component.exports